import { TProfileEdgeCrease } from './t-profile-edge-crease';
import { ProfileV1Line } from './profile-v1-line';

export function recalculateStartLineAngle(angle: number, direction: number, rotateAngle: number): { angle: number; direction: number } {
    angle += rotateAngle;
    if (Math.abs(angle) > 360) {
        angle %= 360;
    }
    if (angle > 180) {
        angle -= 360;
        direction = -1;
    }
    if (angle > 0 && angle <= 180) {
        direction = 1;
    }
    if (angle > -180 && angle <= 0) {
        direction = -1;
    }
    if (angle <= -180) {
        angle += 360;
        direction = 1;
    }
    return { angle, direction };
}

export function parseEdgeCrease(value: string): TProfileEdgeCrease {
    switch (value) {
        case '-1':
            return -1;
        case '0':
            return 0;
        case '1':
            return 1;
        default:
            return 0;
    }
}

export interface LengthTotalData {
    lines: ProfileV1Line[];
    edgeCreaseSizeMM: number;
    creaseLeft: TProfileEdgeCrease;
    creaseRight: TProfileEdgeCrease;
}

export function calculateLengthTotal(data: LengthTotalData): number {
    let len = data.lines.reduce((sum: number, line: ProfileV1Line) => sum + Math.max(line.length, line.length2), 0);
    len += data.creaseLeft === 0 ? 0 : data.edgeCreaseSizeMM;
    len += data.creaseRight === 0 ? 0 : data.edgeCreaseSizeMM;
    return len;
}
